import React from 'react';
import { Input, Button, Alert } from 'antd';
import { CARD_VERIFICATION_TEXTS } from '../helpers/misc';

const CardVerification = ({ 
  cardCode, 
  error, 
  loading, 
  onCardCodeChange, 
  onVerifyClick 
}) => {

  const handleInputChange = (e) => {
    const cleanedValue = e.target.value.replace(/\D/g, '').slice(0, 13);
    onCardCodeChange(cleanedValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && cardCode.length === 13 && !loading) {
      onVerifyClick();
    }
  };

  return (
    <div className="verification-box" style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
      <div className="instruction">{CARD_VERIFICATION_TEXTS.instruction}</div>
      <p>{CARD_VERIFICATION_TEXTS.helper_text}</p>
      <Input
        placeholder={CARD_VERIFICATION_TEXTS.placeholder}
        value={cardCode}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        maxLength={13}
        inputMode="numeric" /*MA: NENASEL JSEM VE SPECIFIKACI Z ANTD. NAJDI K TOMU DOKUMANTACI A POSLI PROSIM */
        pattern="[0-9]*" /*MA: NENASEL JSEM VE SPECIFIKACI Z ANTD. NAJDI K TOMU DOKUMANTACI A POSLI PROSIM */
        style={{width: "auto", marginTop: "1em", textAlign: "center"}}
      />
      {error && (
        <Alert message={error} type="error" style={{ marginTop: 16, marginBottom: 16 }} />
      )}
      <Button
        type="primary"
        onClick={onVerifyClick}
        disabled={cardCode.length < 13 || loading}
        style={{ margin: " 2em 0 1em"}}
      >
        {CARD_VERIFICATION_TEXTS.button}
      </Button>
      <p>Ak ešte nie ste členom Vernostného programu BENU, môžete sa ním stať v ktorejkoľvek lekárni BENU, kde Vám vydajú plastovú kartu, alebo sa zaregistrovať online na <a href="https://karta.benulekaren.sk" target="_blank">karta.benulekaren.sk</a> a získať virtuálnu Vernostnú kartu BENU. V prípade otázok nás prosím kontaktujte na <a href="mailto:podpora@benulekaren.sk">podpora@benulekaren.sk</a>.</p>
    </div>
  );
};

export default CardVerification;
